module.exports = __webpack_public_path__ + "static/img/image-1.e2744f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/image-1.jpg
// module id = 145
// module chunks = 1